import DATA from "./DATA" 
import formatNumber  from './formatNumber'   
import moment from 'moment'  
import WORKER from 'simple-web-worker'
let NAME = "Actions" 

const toNumber=formatNumber.toNumber
const toMoney=formatNumber.toMoney
const toSameLength=formatNumber.toSameLength


 
const toDateTime =(date_string)=>{ 
    let date = moment(date_string).format('yyyy/MM/DD HH:mm') 
    return  date  
}
const toDate = (date_string)=>{ 
    let date = moment(date_string).format('yyyy/MM/DD') 
    return  date  
}
const toTime = (date_string)=>{ 
    let time = moment(date_string).format('HH:mm') 
    return  time  
}
const TEXT_UP = (text)=>{ 
    if (!text) {return null}
    let tx = text.toUpperCase()
    return tx  
}
const TEXT_UP1 = (text)=>{ 
    if (!text) {return null}
    let tx = text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    return tx  
}
const TEXT_UP11 = (text)=>{ 
    if (!text) {return null}
    var splitStr = text.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) { 
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    } 
    return splitStr.join(' ');   
}
const TEXT_UP0 = (text)=>{ 
    if (!text) {return null} 
    if (typeof text != "string") {return null} 
    return text.toLowerCase();   
}
const TEXT_EQ = (text,text2)=>{ 
    if (TEXT_UP(text)===TEXT_UP(text2)) {
        return true
    } 
    return false   
}
const TEXT_SPLIT_N = (text)=>{ 
    if(!text){return null}
    return text.split('\n')  
}
const TEXT_SPACE0 = (text)=>{ 
    if(!text){return ''}
    return text.replace(/\s/g,'')  
}
const SIZE = (item)=>{ 
    if(!item) {return 0}
    return item.length  
}
const DEFINED_ONLY = (obj)=>{ 
    if(!obj) {return null}
    if (typeof obj === 'object' && obj !== null) {
        let newObj = [] 
        for (const key in obj) {
            let item = obj[key]
            if (item) { 
                newObj[key]=item 
            }
        }
        return newObj
    }
    return null 
}
const mbs = {
        toDateTime:toDateTime, 
        toDate:toDate,
        toTime:toTime,
        TEXT_UP:TEXT_UP,
        TEXT_UP1:TEXT_UP1,
        TEXT_UP11:TEXT_UP11,
        TEXT_UP0:TEXT_UP0,
        TEXT_EQ:TEXT_EQ,
        TEXT_SPLIT_N:TEXT_SPLIT_N,
        TEXT_SPACE0:TEXT_SPACE0,
        DEFINED_ONLY:DEFINED_ONLY
    } 

 
export { 
    toDateTime, 
    toDate,
    toTime,
    TEXT_UP,
    TEXT_UP1,
    TEXT_UP11,
    TEXT_UP0,
    TEXT_EQ,
    TEXT_SPLIT_N,
    TEXT_SPACE0, 
    SIZE, 
    DEFINED_ONLY
};